// import loadingStates from "../constants/loadingStates";
import initialState from "../store/initialState";
import { createSelector } from "./createSelector";

const selectDomain = (state) => state.auth || initialState.auth;

export const selectIsLoggedIn = createSelector(
  selectDomain,
  state => state.isLoggedIn
);

const selectCurrentUser = createSelector(
  selectDomain,
  state => state.currentUser,
);

export const selectRegisteredCourses = createSelector(
  selectCurrentUser,
  (currentUser = {}) => currentUser.registeredCourses
);

export const selectIsLoadingRegisteredCourses = createSelector(
  selectDomain,
  (state) => state.isLoadingRegisteredCourses
);
